module.exports = __webpack_public_path__ + "media/images/front/materials/textil-d38a1f231b3d877ccdb72db6dd770fd8.jpg";